"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("../index.scss");
const mobx_react_1 = require("mobx-react");
const Button_1 = require("@Components/Buttons/Button");
const navigation_1 = __importDefault(require("@App/navigation"));
const contexts_1 = require("@App/contexts");
const CancelUploadModal_1 = __importDefault(require("@Components/CreateWorkBottomNavs/FileUploadBottomNavBar/CancelUploadModal"));
const GoBackModal_1 = __importDefault(require("@Components/CreateWorkBottomNavs/FileUploadBottomNavBar/GoBackModal"));
const SaveToDraftModal_1 = __importDefault(require("@Components/CreateWorkBottomNavs/FileUploadBottomNavBar/SaveToDraftModal"));
const pluralize_1 = __importDefault(require("pluralize"));
const FileUploadBottomNavBar = (props) => {
    var _a;
    const { backLink, nextLink, currentStep, navigate } = props;
    const { rightsholderStore, bulkUploadStore, workStore, preloaderStore, userStore, popupStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [redirectURL, setRedirectUrl] = (0, react_1.useState)();
    const [sidebarIsOpen, setSidebarIsOpen] = (0, react_1.useState)(false);
    const [submittedCountWorks, setSubmittedCountWorksState] = (0, react_1.useState)();
    const [isDraftsSaved, setIsDraftsSaved] = (0, react_1.useState)(false);
    const [bulkUploadReviewModalIsOpen, setBulkUploadReviewModalIsOpen] = (0, react_1.useState)(false);
    const [individualWorkModalIsOpen, setIndividualWorkModalIsOpen] = (0, react_1.useState)(false);
    if (redirectURL) {
        navigate(redirectURL);
    }
    const uploadFile = () => __awaiter(void 0, void 0, void 0, function* () {
        const rightsHolderId = rightsholderStore.currentRightsholderId;
        if (!nextLink || !rightsHolderId) {
            return;
        }
        try {
            preloaderStore.openTransparentPreloader(true);
            yield bulkUploadStore.getCurrentWorksFromUploadFile(rightsHolderId);
            bulkUploadStore.destroyStartTitlePositionWorkSubmissions();
            preloaderStore.openTransparentPreloader(false);
            navigate(nextLink);
        }
        catch (ignore) {
            preloaderStore.openTransparentPreloader(false);
        }
    });
    const setSubmittedCountWorks = () => {
        const allWorksFromUpload = bulkUploadStore.allWorksFromUpload;
        if (!allWorksFromUpload) {
            return;
        }
        setIsDraftsSaved(false);
        setSubmittedCountWorksState(allWorksFromUpload.complete.length);
    };
    const saveWork = () => {
        const workDraftFromLocal = workStore.workDraftLocal;
        if (!workDraftFromLocal) {
            return;
        }
        bulkUploadStore.formatWorksForSaving(workDraftFromLocal);
        if (!nextLink) {
            return;
        }
        navigate(nextLink);
    };
    const checkSaveStatusDraft = () => {
        const allWorksFromUpload = bulkUploadStore.allWorksFromUpload;
        const rightsHolderId = rightsholderStore.currentRightsholderId;
        if (!allWorksFromUpload || !rightsHolderId) {
            return;
        }
        // if error works exists
        if (!isDraftsSaved && allWorksFromUpload.error.length) {
            setSidebarIsOpen(true);
        }
        else {
            bulkUploadStore.destroyAllWorksFromUpload();
            setRedirectUrl(navigation_1.default.rightholder.registrationHistory.root(rightsHolderId));
        }
    };
    const saveDraftsFromPopup = (isSave) => __awaiter(void 0, void 0, void 0, function* () {
        const rightsHolderId = rightsholderStore.currentRightsholderId;
        if (!rightsHolderId) {
            return;
        }
        if (isSave) {
            yield saveAllDrafts(true);
        }
        bulkUploadStore.destroyAllWorksFromUpload();
        setRedirectUrl(navigation_1.default.rightholder.registrationDrafts.root(rightsHolderId));
    });
    const saveAllDrafts = (...args_1) => __awaiter(void 0, [...args_1], void 0, function* (errorsOnly = false) {
        const allWorksFromUpload = bulkUploadStore.allWorksFromUpload;
        const rightsHolderId = rightsholderStore.currentRightsholderId;
        if (!allWorksFromUpload || !rightsHolderId) {
            return;
        }
        if (!('error' in allWorksFromUpload)) {
            return;
        }
        else {
            const draftsToSave = Object.assign(Object.assign({}, allWorksFromUpload), { saveErrorsOnly: true, isComplete: false });
            if (errorsOnly) {
                draftsToSave.all = allWorksFromUpload.error;
                draftsToSave.complete = [];
            }
            try {
                preloaderStore.openTransparentPreloader(true);
                yield bulkUploadStore.saveUploadWorks(rightsHolderId, draftsToSave);
                popupStore.setAlertData('Works saved to draft successfully', false);
                setIsDraftsSaved(true);
            }
            catch (e) {
                popupStore.setAlertFromError(e);
            }
            finally {
                preloaderStore.openTransparentPreloader(false);
            }
        }
    });
    const saveAllWorks = () => __awaiter(void 0, void 0, void 0, function* () {
        const allWorksFromUpload = bulkUploadStore.allWorksFromUpload;
        const rightsHolderId = rightsholderStore.currentRightsholderId;
        if (!allWorksFromUpload || !rightsHolderId) {
            return;
        }
        const worksToSave = Object.assign(Object.assign({}, allWorksFromUpload), { isComplete: true });
        try {
            preloaderStore.openTransparentPreloader(true);
            yield bulkUploadStore.saveUploadWorks(rightsHolderId, worksToSave);
            bulkUploadStore.setCurrentFileId(worksToSave.fileId);
            if (!nextLink) {
                return;
            }
            navigate(nextLink);
            // remove start title position
            bulkUploadStore.destroyStartTitlePositionWorkSubmissions();
            // get complete works from backend
            yield bulkUploadStore.getCompleteWorksFromUpload(rightsHolderId);
            preloaderStore.openTransparentPreloader(false);
        }
        catch (e) {
            popupStore.setAlertFromError(e);
            preloaderStore.openTransparentPreloader(false);
        }
    });
    (0, react_1.useEffect)(() => {
        setSubmittedCountWorks();
    }, [(_a = bulkUploadStore.allWorksFromUpload) === null || _a === void 0 ? void 0 : _a.complete.length]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(CancelUploadModal_1.default, { bulkUploadReviewModalIsOpen: bulkUploadReviewModalIsOpen, closeBulkUploadReviewModal: () => setBulkUploadReviewModalIsOpen(false) }),
        react_1.default.createElement(GoBackModal_1.default, { individualWorkModalIsOpen: individualWorkModalIsOpen, closeIndividualWorkModal: () => setIndividualWorkModalIsOpen(false), backLink: backLink }),
        react_1.default.createElement("div", { className: 'next-back-bar-bottom' },
            react_1.default.createElement("div", { className: 'next-back-bar-bottom-content' },
                currentStep !== 2 && currentStep !== 3 && currentStep !== 4 && (react_1.default.createElement(Button_1.Button, { mainColor: true, className: 'back', type: 'secondary', typeLink: !!backLink, linkTo: backLink }, "Back")),
                currentStep === 3 && (react_1.default.createElement(Button_1.Button, { mainColor: true, className: 'back', type: 'secondary', onClick: () => setIndividualWorkModalIsOpen(true) }, "Back")),
                currentStep === 2 && (react_1.default.createElement("p", { onClick: () => setBulkUploadReviewModalIsOpen(true), className: 'link small bold cancel linkcolor' }, "Cancel and Start Over")),
                react_1.default.createElement("div", null),
                react_1.default.createElement("div", { className: 'right' },
                    currentStep === 1 && (react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', className: 'next', onClick: uploadFile, disabled: !workStore.wizardStepIsValid }, "Upload")),
                    currentStep === 2 && (react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', className: 'next', onClick: saveAllWorks, disabled: !submittedCountWorks || userStore.isInternal }, `Submit ${(0, pluralize_1.default)('work', submittedCountWorks, true)}`)),
                    currentStep === 3 && (react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', className: 'next', onClick: () => {
                            saveWork();
                        }, disabled: !workStore.wizardStepIsValid }, "Save")),
                    currentStep === 4 && (react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', className: 'next', onClick: checkSaveStatusDraft }, "Done")))),
            react_1.default.createElement(SaveToDraftModal_1.default, { setSidebarIsOpen: setSidebarIsOpen, saveDraftsFromPopup: saveDraftsFromPopup, sidebarIsOpen: sidebarIsOpen }))));
};
exports.default = (0, mobx_react_1.observer)(FileUploadBottomNavBar);
